import { Quote } from "lucide-react";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_digital-partner-hub-3/artifacts/u47b85vj__35A9001.JPG";

const stats = [
  { value: "1", label: "Interlocuteur" },
  { value: "6", label: "Projets livrés" },
  { value: "100 %", label: "Sur-mesure" },
];

export default function About() {
  return (
    <section
      id="a-propos"
      data-testid="about-section"
      className="py-20 md:py-32 relative overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="rounded-3xl overflow-hidden dark-aurora-radial text-white shadow-tactile-lg paper relative">
          <div className="grid grid-cols-12 relative">
            {/* Photo */}
            <div className="col-span-12 md:col-span-5 relative min-h-[420px] md:min-h-[640px]">
              <img
                src={ABOUT_IMG}
                alt="David Devos — Studio indépendant"
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover"
                style={{ objectPosition: "50% 28%" }}
              />
              <div className="absolute bottom-5 left-5 btn-aurora text-white rounded-2xl px-4 py-3 shadow-tactile-lg">
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/85 font-bold">
                  Studio · Bruxelles
                </div>
                <div className="font-display text-xl font-medium text-white">
                  David Devos
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="col-span-12 md:col-span-7 p-8 md:p-14 lg:p-16 relative">
              <Quote
                className="absolute top-4 right-4 md:top-8 md:right-8 text-white/10 w-10 h-10 md:w-[72px] md:h-[72px]"
                strokeWidth={1}
                aria-hidden="true"
              />
              <span className="eyebrow text-aurora">— À propos</span>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight font-medium mt-5 leading-[1.1] text-white">
                Plus qu'un créateur de site, un{" "}
                <em className="not-italic italic font-light text-aurora">
                  partenaire
                </em>{" "}
                pour votre{" "}
                <em className="not-italic italic font-light text-aurora">
                  présence en ligne.
                </em>
              </h2>

              <div className="mt-8 space-y-5 text-white/85 leading-relaxed text-base md:text-lg max-w-xl">
                <p>
                  Depuis plus de 4 ans, je développe mon expérience dans la
                  création de sites web et la présence numérique. D'abord à
                  travers des projets personnels, puis en accompagnant
                  artisans, indépendants, petites entreprises et associations
                  désireux de gagner en visibilité.
                </p>
                <p>
                  Pas d'usine à sites, pas de jargon. Ici je vous propose un
                  contact direct, sans intermédiaire, pour créer une présence
                  en ligne professionnelle, cohérente et fidèle à votre
                  savoir-faire.
                </p>
              </div>

              <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8 max-w-xl">
                {stats.map((s) => (
                  <div
                    key={s.label}
                    data-testid={`about-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="border-t border-white/20 pt-4"
                  >
                    <div
                      className="font-display text-3xl md:text-4xl font-medium leading-none"
                      style={{ color: "#A855F7" }}
                    >
                      {s.value}
                    </div>
                    <div className="mt-2 text-[10px] md:text-xs uppercase tracking-[0.12em] md:tracking-[0.18em] text-white/70 font-medium break-words hyphens-auto">
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
